import { render, staticRenderFns } from "./SelectorTarget.vue?vue&type=template&id=12c4833b&scoped=true&"
import script from "./SelectorTarget.vue?vue&type=script&lang=js&"
export * from "./SelectorTarget.vue?vue&type=script&lang=js&"
import style0 from "./SelectorTarget.vue?vue&type=style&index=0&id=12c4833b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c4833b",
  null
  
)

export default component.exports